import {OpenStreetMapProvider} from 'leaflet-geosearch';
window.OpenStreetMapProvider = OpenStreetMapProvider;